<template>
<div>
  <div class="balance">
    <div class="top">
      <div class="item item1">
        <div class="tit">会员余额</div>
        <div v-if="account.money" class="num">{{account.money.toFixed(2)}}</div>
        <router-link :to="{ name: 'recharge' }" class="alink">充值</router-link>
      </div>
      <div v-if="account.is_company > 0" class="item item2">
        <div class="tit">{{account.company_title}}</div>
        <div v-if="account.money_company" class="num">{{account.money_company.toFixed(2)}}</div>
        <div class="time">截止日期：{{account.company_expire_at}}</div>
      </div>
    </div>
    <div class="app-num-list topline">
      <div class="bigtit">资金变动记录</div>

      <div v-if="list.length > 0" class="weui-cells">
          <div v-for="(v,k) in list" v-bind:key="k" class="weui-cell">
              <div class="weui-cell__bd">
                  <p class="tit">{{v.note}}</p>
                  <p class="time">{{v.updated_at}}</p>
              </div>
              <div class="weui-cell__ft num" :class="[v.money>=0?'add':'minus']">{{v.money.toFixed(2)}}</div>
          </div>
      </div>
      <div v-else class="nodata">暂无数据</div>
    </div>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
  </div>
  <div class="weui-loadmore" v-if="load">
      <i class="weui-loading"></i>
      <span class="weui-loadmore__tips">正在加载</span>
  </div>
</div>
</template>
<script>
import infiniteScroll from '@/basic/infiniteScroll'
export default{
  directives: {infiniteScroll},
  data(){
    return{
      account:{},
      list:[],
      busy: true,
      load:true,
      page:1
    }
  },
  mounted() {
    this.getAccount();
    this.getAccountMoneyLog()
  },
  methods:{
    getAccount(){
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
      })
    },
    getAccountMoneyLog(flag){
      let vm = this;
      vm.ajax("account/money/log", "get", 'page='+vm.page, e => {
        vm.load = false;
        if(e.data.list){
          if(flag){
            vm.list =  vm.list.concat(e.data.list)
            if(e.data.count == vm.page){
                vm.busy = true;
            }else{
                vm.busy = false;
            }
          }else{
            vm.list =  e.data.list;
            if(vm.list.length < e.data.limit){
              vm.busy = true;
            }else{
              vm.busy = false;
            }
          }
        }else{
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
          vm.page++;
          vm.getAccountMoneyLog(true);
      }, 1000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/balance.vue